import barba from '@barba/core';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class {
	constructor() {
		barba.hooks.beforeOnce((data) => {
            this.init()
        });
        barba.hooks.after((data) => {
			this.init();
        });
	}

	init() {
		const strs = document.querySelectorAll("[data-nav-str]");
		// strs.forEach((target) => {
		// 	let newText = ''; // 修正: newText を宣言
		// 	let newTextBefore = ''; // 修正: newTextBefore を宣言
		// 	let newTextAfter = ''; // 修正: newTextAfter を宣言
		// 	const spanText = target.innerHTML;
		// 	spanText.split('').forEach((char) => {
		// 		newText += '<span>' + char + '</span>';
		// 	});
		// 	newTextBefore = "<div class='before'>"+newText+"</div>";
		// 	newTextAfter = "<div class='after'>"+newText+"</div>";
		// 	newText = "<span class='text-wrap'>"+newTextBefore + newTextAfter+"</span>";
		// 	target.innerHTML = newText;

		// 	let beforeSpan = target.querySelector('.before').querySelectorAll('span');
		// 	let afterSpan = target.querySelector('.after').querySelectorAll('span');
		// 	target.addEventListener('mouseenter', () => {
		// 		gsap.to(beforeSpan, { y: '-100%', stagger: 0.03, ease: "power2.out" });
		// 		gsap.to(afterSpan, { y: '0%', stagger: 0.03, ease: "power2.out" });
		// 	});
		// 	target.addEventListener('mouseleave', () => {
		// 		gsap.to(beforeSpan, { y: '0%', stagger: 0.03, ease: "power2.out" });
		// 		gsap.to(afterSpan, { y: '100%', stagger: 0.03, ease: "power2.out" });
		// 	});
		// });
	}
}
